import { FC } from 'react';

import { Spinner } from 'src/components/spinner';
import { UserForm } from 'src/features/your-details/user-form';
import { UserFormProps } from 'src/features/your-details/user-form/types';
import { Building } from 'src/store/types/building';
import { Room } from 'src/store/types/room';

type OccupantDetailsFormProps = {
    data: {
        room: Room;
        building: Building;
    } | null;
    loading: boolean;
    userFormProps: UserFormProps;
};

export const OccupantDetailsForm: FC<OccupantDetailsFormProps> = ({
    userFormProps,
    loading,
    data,
}) => (loading ? <Spinner size="big" /> : data && <UserForm {...userFormProps} />);
